<template>
    <v-dialog
        v-model="deleteImageDialog"
        hide-overlay
        width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-if="useHeaderButton"
                class="ma-1 text-subtitle-2 float-right"
                style="text-transform: none !important"
                outlined
                light
                :disabled="!images.length || multiSelectDisabled"
                v-bind="attrs"
                @click="openModel"
            >
                <v-icon
                    class="material-icons-outlined"
                >
                    delete
                </v-icon>
                Delete
            </v-btn>
            <v-icon
                v-else
                :disabled="singleSelectDisabled"
                class="material-icons-outlined"
                v-bind="attrs"
                @click="openModel"
            >
                delete
            </v-icon>
        </template>
        <v-card>
            <v-card-title class="text-h5 lighten-2">
                <span>Delete</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <div
                    v-if="imageCount === 1"
                    id="delete-image-container"
                >
                    Are you sure you want to delete "{{ imageCaption }}" from the image list?
                </div>
                <div
                    v-else
                    id="delete-image-container"
                >
                    Are you sure you want to delete "{{ selectedImagesName.join(", ") }}" from the image list?
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn
                    outlined
                    light
                    @click="closedModel"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    @click="imageDelete"
                >
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';

export default {
    props: {
        images: {
            type: Array,
            required: true,
            default: () => [],
        },
        useHeaderButton: {
            type: Boolean,
            required: true,
        },
        imageCaption: {
            type: String,
            required: false,
            default: '',
        },
        selectedImagesName: {
            type: Array,
            required: false,
            default: () => [],
        },
        singleSelectDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: () => ({
        deleteImageDialog: false
    }),
    computed: {
        imageCount() {
            return this.images.length;
        },
        multiSelectDisabled() {
            if(this.offline) {
                return this.images.filter(image => {
                    return !image.offline;
                }).length > 0;
            }
            return false;
        },
        offline() {
            return this.$store.getters.forceOffline;
        },
    },
    methods: {
        closedModel() {
            this.deleteImageDialog = false;
        },
        openModel() {
            this.deleteImageDialog = true;
        },
        async imageDelete() {
            for(let image of this.images) {
                let request = {
                    offline: image.offline || undefined,
                    operation: 'delete',
                    rowid: image.rowid,
                    __TIMESTAMP__: new Date().getTime()
                };
                let response = await webtmsBackend.deleteImage(request);
                if(response.result !== 'OK'){
                    console.error('imageDelete failed with error ', response);
                }
            }
            this.$emit('load-ticket-details');
            this.closedModel();
        }
    }
};
</script>
<style>
    #delete-image-container {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.0025em;
        color: var(--ll-text-primary);
        margin: 16px 0px;
    }
</style>
